import { PlusIcon } from '@shopify/polaris-icons';
import { Modal, Select } from '../forms';
import { useState } from 'react';
import { Banner, BlockStack, Button, Text } from '@shopify/polaris';
import { useApi } from '../../hooks/useApi';
import { useAuth } from '../../App';
import type { Shipment } from './types';

export default function ShipmentRoute({ shipment, onSaved }: { shipment: Shipment; onSaved: () => void }) {
  const { hasPermission } = useAuth(); const { fetchApi, error } = useApi();
  const [open, setOpen] = useState(false); const [pending, setPending] = useState(false); const [routeId, setRouteId] = useState('');
  const [routes, setRoutes] = useState<Array<{ id: number; name: string; delivery_date: string }>>([]);
  if (shipment.route) return <Button url={`/routes/${shipment.route.route_id}`}>{shipment.route.name || 'View route'} · {shipment.route.delivery_date}</Button>;
  if (shipment.delivery_method !== 'own_van' || shipment.status === 'cancelled' || shipment.delivered_quantity >= shipment.quantity || !hasPermission('routes.update')) return null;
  const show = async () => {
    setOpen(true); setPending(true); const result = await fetchApi<{ routes: typeof routes }>('/api/shipments/routes/available');
    setRoutes(result?.routes || []); setPending(false);
  };
  const save = async () => {
    setPending(true); const result = await fetchApi<{ success: boolean }>(`/api/shipments/${encodeURIComponent(shipment.id)}/route`, {
      method: 'POST', body: JSON.stringify({ revision: shipment.revision, route_id: Number(routeId) }),
    }); setPending(false); if (result?.success) { setOpen(false); onSaved(); }
  };
  return <><Button icon={PlusIcon} onClick={show}>Add to van route</Button>
    <Modal open={open} title="Add shipment to a van route" onClose={() => { if (!pending) setOpen(false); }}
      primaryAction={{ icon: PlusIcon, content: 'Add shipment', onAction: save, loading: pending, disabled: pending || !routeId }}
      secondaryActions={[{ content: 'Back', onAction: () => setOpen(false), disabled: pending }]}>
      <Modal.Section><BlockStack gap="300">
        {error && <Banner tone="critical">{error}</Banner>}
        <Text as="p">Only this shipment's remaining items will be on the stop. {shipment.status==='dispatched'?'Check and reload any held goods, then complete the loading checks before starting the route.':'Dispatch this shipment before starting the route.'}</Text>
        <Select label="Draft or planned route" requiredIndicator value={routeId} onChange={setRouteId} disabled={pending}
          options={[{ label: 'Choose route', value: '' }, ...routes.map(r => ({ label: `${r.delivery_date} · ${r.name || `Route ${r.id}`}`, value: String(r.id) }))]} />
        {!pending && !routes.length && <Text as="p">Create a draft route in Delivery Routes first.</Text>}
      </BlockStack></Modal.Section>
    </Modal></>;
}
